export default {
  brands: [],
  models: [],
  years: [],
  version: [],
  item: {}
}
